"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useFlowRuns(query) {
  const { ...rest } = useElements("flow-runs", query);
  return {
    flowRuns: rest.items,
    ...rest
  };
}

export { useFlowRuns };
